import { Report } from '@app/domain';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { GetShiftObservationReportUrlDTO, ReportDTO } from '../dtos/report.dto';

export class ReportMapper {
  shiftObservationReportUrlToDomain(
    dto: GetShiftObservationReportUrlDTO
  ): string {
    return dto?.excelDownloadUrl;
  }

  listStowageComplianceReportToDomain(
    dto: PaginatedResponse<ReportDTO>
  ): PaginatedResponse<Report> {
    const { data } = dto;

    return {
      ...dto,
      data: data.map(report => this.stowageComplianceReportToDomain(report)),
    };
  }

  stowageComplianceReportToDomain(dto: ReportDTO): Report {
    return {
      id: dto.vesselId,
      vesselName: dto.vesselName,
      hasComplianceAt: dto.hasComplianceAt,
      vesselByShiftId: dto.vesselByShiftId,
      berthNumber: dto.berthNumber,
      vesselType: dto.vesselType,
      voyIn: dto.voyIn,
      voyOut: dto.voyOut,
    };
  }
}
